import request from '../utils/request';

export const loginService = params => {
  return async dispatch => {
    const resp = await dispatch(
      request('/login', {
        method: 'POST',
        data: params,
        // TODO: add tenent identifier value in params from subdomain name
      }),
    );
    return resp;
  };
};

export const getUserMe = () => {
  return async dispatch => {
    const resp = await dispatch(
      request('/users/me', {
        method: 'GET',
      }),
    );
    return resp;
  };
};
